import 'isomorphic-fetch'
export const requestHelp = () => ({
    type: 'REQUEST_HELP',
    payload: ''
})